function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { extend } from "../shared/utils/extend.js";
import { round } from "../shared/utils/round.js";
import { isScrollable } from "../shared/utils/isScrollable.js";
import { ResizeObserver } from "../shared/utils/ResizeObserver.js";
import { PointerTracker, getMidpoint, getDistance } from "../shared/utils/PointerTracker.js";
import { getTextNodeFromPoint } from "../shared/utils/getTextNodeFromPoint.js";
import { getFullWidth, getFullHeight, calculateAspectRatioFit } from "../shared/utils/getDimensions.js";
import { Base } from "../shared/Base/Base.js";
import { Plugins } from "./plugins/index.js";
var defaults = {
  // Enable touch guestures
  touch: true,
  // Enable zooming
  zoom: true,
  // Enable pinch gesture to zoom in/out using two fingers
  pinchToZoom: true,
  // Disable dragging if scale level is equal to value of `baseScale` option
  panOnlyZoomed: false,
  // Lock axis while dragging,
  // possible values: false | "x" | "y" | "xy"
  lockAxis: false,
  // * All friction values are inside [0, 1) interval,
  // * where 0 would change instantly, but 0.99 would update extremely slowly
  // Friction while panning/dragging
  friction: 0.64,
  // Friction while decelerating after drag end
  decelFriction: 0.88,
  // Friction while scaling
  zoomFriction: 0.74,
  // Bounciness after hitting the edge
  bounceForce: 0.2,
  // Initial scale level
  baseScale: 1,
  // Minimum scale level
  minScale: 1,
  // Maximum scale level
  maxScale: 2,
  // Default scale step while zooming
  step: 0.5,
  // Allow to select text,
  // if enabled, dragging will be disabled when text selection is detected
  textSelection: false,
  // Add `click` event listener,
  // possible values: true | false | function | "toggleZoom"
  click: "toggleZoom",
  // Add `wheel` event listener,
  // possible values: true | false | function |  "zoom"
  wheel: "zoom",
  // Value for zoom on mouse wheel
  wheelFactor: 42,
  // Number of wheel events after which it should stop preventing default behaviour of mouse wheel
  wheelLimit: 5,
  // Class name added to `$viewport` element to indicate if content is draggable
  draggableClass: "is-draggable",
  // Class name added to `$viewport` element to indicate that user is currently dragging
  draggingClass: "is-dragging",
  // Content will be scaled by this number,
  // this can also be a function which should return a number, for example:
  // ratio: function() { return 1 / (window.devicePixelRatio || 1) }
  ratio: 1
};
export var Panzoom = /*#__PURE__*/function (_Base) {
  _inherits(Panzoom, _Base);

  var _super = _createSuper(Panzoom);

  /**
   * Panzoom constructor
   * @constructs Panzoom
   * @param {HTMLElement} $viewport Panzoom container
   * @param {Object} [options] Options for Panzoom
   */
  function Panzoom($container) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Panzoom);

    _this = _super.call(this, extend(true, {}, defaults, options));
    _this.state = "init";
    _this.$container = $container; // Bind event handlers for referencability

    for (var _i = 0, _arr = ["onLoad", "onWheel", "onClick"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      _this[methodName] = _this[methodName].bind(_assertThisInitialized(_this));
    }

    _this.initLayout();

    _this.resetValues();

    _this.attachPlugins(Panzoom.Plugins);

    _this.trigger("init");

    _this.updateMetrics();

    _this.attachEvents();

    _this.trigger("ready");

    if (_this.option("centerOnStart") === false) {
      _this.state = "ready";
    } else {
      _this.panTo({
        friction: 0
      });
    }

    $container.__Panzoom = _assertThisInitialized(_this);
    return _this;
  }
  /**
   * Create references to container, viewport and content elements
   */


  _createClass(Panzoom, [{
    key: "initLayout",
    value: function initLayout() {
      var $container = this.$container; // Make sure content element exists

      if (!($container instanceof HTMLElement)) {
        throw new Error("Panzoom: Container not found");
      }

      var $content = this.option("content") || $container.querySelector(".panzoom__content"); // Make sure content element exists

      if (!$content) {
        throw new Error("Panzoom: Content not found");
      }

      this.$content = $content;
      var $viewport = this.option("viewport") || $container.querySelector(".panzoom__viewport");

      if (!$viewport && this.option("wrapInner") !== false) {
        var _$viewport;

        $viewport = document.createElement("div");
        $viewport.classList.add("panzoom__viewport");

        (_$viewport = $viewport).append.apply(_$viewport, _toConsumableArray($container.childNodes));

        $container.appendChild($viewport);
      }

      this.$viewport = $viewport || $content.parentNode;
    }
    /**
     * Restore instance variables to default values
     */

  }, {
    key: "resetValues",
    value: function resetValues() {
      this.updateRate = this.option("updateRate", /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 250 : 24);
      this.container = {
        width: 0,
        height: 0
      };
      this.viewport = {
        width: 0,
        height: 0
      };
      this.content = {
        // Full content dimensions (naturalWidth/naturalHeight for images)
        origWidth: 0,
        origHeight: 0,
        // Current dimensions of the content
        width: 0,
        height: 0,
        // Current position; these values reflect CSS `transform` value
        x: this.option("x", 0),
        y: this.option("y", 0),
        // Current scale; does not reflect CSS `transform` value
        scale: this.option("baseScale")
      }; // End values of current pan / zoom animation

      this.transform = {
        x: 0,
        y: 0,
        scale: 1
      };
      this.resetDragPosition();
    }
    /**
     * Handle `load` event
     * @param {Event} event
     */

  }, {
    key: "onLoad",
    value: function onLoad(event) {
      this.updateMetrics();
      this.panTo({
        scale: this.option("baseScale"),
        friction: 0
      });
      this.trigger("load", event);
    }
    /**
     * Handle `click` event
     * @param {Event} event
     */

  }, {
    key: "onClick",
    value: function onClick(event) {
      if (event.defaultPrevented) {
        return;
      } // Skip if text is selected


      if (this.option("textSelection") && window.getSelection().toString().length) {
        event.stopPropagation();
        return;
      }

      var rect = this.$content.getClientRects()[0]; // Check if container has changed position (for example, when current instance is inside another one)

      if (this.state !== "ready") {
        if (this.dragPosition.midPoint || Math.abs(rect.top - this.dragStart.rect.top) > 1 || Math.abs(rect.left - this.dragStart.rect.left) > 1) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }

      if (this.trigger("click", event) === false) {
        return;
      }

      if (this.option("zoom") && this.option("click") === "toggleZoom") {
        event.preventDefault();
        event.stopPropagation();
        this.zoomWithClick(event);
      }
    }
    /**
     * Handle `wheel` event
     * @param {Event} event
     */

  }, {
    key: "onWheel",
    value: function onWheel(event) {
      if (this.trigger("wheel", event) === false) {
        return;
      }

      if (this.option("zoom") && this.option("wheel")) {
        this.zoomWithWheel(event);
      }
    }
    /**
     * Change zoom level depending on scroll direction
     * @param {Event} event `wheel` event
     */

  }, {
    key: "zoomWithWheel",
    value: function zoomWithWheel(event) {
      if (this.changedDelta === undefined) {
        this.changedDelta = 0;
      }

      var delta = Math.max(-1, Math.min(1, -event.deltaY || -event.deltaX || event.wheelDelta || -event.detail));
      var scale = this.content.scale;
      var newScale = scale * (100 + delta * this.option("wheelFactor")) / 100;

      if (delta < 0 && Math.abs(scale - this.option("minScale")) < 0.01 || delta > 0 && Math.abs(scale - this.option("maxScale")) < 0.01) {
        this.changedDelta += Math.abs(delta);
        newScale = scale;
      } else {
        this.changedDelta = 0;
        newScale = Math.max(Math.min(newScale, this.option("maxScale")), this.option("minScale"));
      }

      if (this.changedDelta > this.option("wheelLimit")) {
        return;
      }

      event.preventDefault();

      if (newScale === scale) {
        return;
      }

      var rect = this.$content.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      this.zoomTo(newScale, {
        x: x,
        y: y
      });
    }
    /**
     * Change zoom level depending on click coordinates
     * @param {Event} event `click` event
     */

  }, {
    key: "zoomWithClick",
    value: function zoomWithClick(event) {
      var rect = this.$content.getClientRects()[0];
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      this.toggleZoom({
        x: x,
        y: y
      });
    }
    /**
     * Attach load, wheel and click event listeners, initialize `resizeObserver` and `PointerTracker`
     */

  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;

      this.$content.addEventListener("load", this.onLoad);
      this.$container.addEventListener("wheel", this.onWheel, {
        passive: false
      });
      this.$container.addEventListener("click", this.onClick, {
        passive: false
      });
      this.initObserver();
      var pointerTracker = new PointerTracker(this.$container, {
        start: function start(pointer, event) {
          if (!_this2.option("touch")) {
            return false;
          }

          if (_this2.velocity.scale < 0) {
            return false;
          }

          var target = event.composedPath()[0];

          if (!pointerTracker.currentPointers.length) {
            var ignoreClickedElement = ["BUTTON", "TEXTAREA", "OPTION", "INPUT", "SELECT", "VIDEO"].indexOf(target.nodeName) !== -1;

            if (ignoreClickedElement) {
              return false;
            } // Allow text selection


            if (_this2.option("textSelection") && getTextNodeFromPoint(target, pointer.clientX, pointer.clientY)) {
              return false;
            }
          }

          if (isScrollable(target)) {
            return false;
          }

          if (_this2.trigger("touchStart", event) === false) {
            return false;
          }

          if (event.type === "mousedown") {
            event.preventDefault();
          }

          _this2.state = "pointerdown";

          _this2.resetDragPosition();

          _this2.dragPosition.midPoint = null;
          _this2.dragPosition.time = Date.now();
          return true;
        },
        move: function move(previousPointers, currentPointers, event) {
          if (_this2.state !== "pointerdown") {
            return;
          }

          if (_this2.trigger("touchMove", event) === false) {
            event.preventDefault();
            return;
          } // Disable touch action if current zoom level is below base level


          if (currentPointers.length < 2 && _this2.option("panOnlyZoomed") === true && _this2.content.width <= _this2.viewport.width && _this2.content.height <= _this2.viewport.height && _this2.transform.scale <= _this2.option("baseScale")) {
            return;
          }

          if (currentPointers.length > 1 && (!_this2.option("zoom") || _this2.option("pinchToZoom") === false)) {
            return;
          }

          var prevMidpoint = getMidpoint(previousPointers[0], previousPointers[1]);
          var newMidpoint = getMidpoint(currentPointers[0], currentPointers[1]);
          var panX = newMidpoint.clientX - prevMidpoint.clientX;
          var panY = newMidpoint.clientY - prevMidpoint.clientY;
          var prevDistance = getDistance(previousPointers[0], previousPointers[1]);
          var newDistance = getDistance(currentPointers[0], currentPointers[1]);
          var scaleDiff = prevDistance && newDistance ? newDistance / prevDistance : 1;
          _this2.dragOffset.x += panX;
          _this2.dragOffset.y += panY;
          _this2.dragOffset.scale *= scaleDiff;
          _this2.dragOffset.time = Date.now() - _this2.dragPosition.time;

          var axisToLock = _this2.dragStart.scale === 1 && _this2.option("lockAxis");

          if (axisToLock && !_this2.lockAxis) {
            if (Math.abs(_this2.dragOffset.x) < 6 && Math.abs(_this2.dragOffset.y) < 6) {
              event.preventDefault();
              return;
            }

            var angle = Math.abs(Math.atan2(_this2.dragOffset.y, _this2.dragOffset.x) * 180 / Math.PI);
            _this2.lockAxis = angle > 45 && angle < 135 ? "y" : "x";
          }

          if (axisToLock !== "xy" && _this2.lockAxis === "y") {
            return;
          }

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          if (_this2.lockAxis) {
            _this2.dragOffset[_this2.lockAxis === "x" ? "y" : "x"] = 0;
          }

          _this2.$container.classList.add(_this2.option("draggingClass"));

          if (!(_this2.transform.scale === _this2.option("baseScale") && _this2.lockAxis === "y")) {
            _this2.dragPosition.x = _this2.dragStart.x + _this2.dragOffset.x;
          }

          if (!(_this2.transform.scale === _this2.option("baseScale") && _this2.lockAxis === "x")) {
            _this2.dragPosition.y = _this2.dragStart.y + _this2.dragOffset.y;
          }

          _this2.dragPosition.scale = _this2.dragStart.scale * _this2.dragOffset.scale;

          if (currentPointers.length > 1) {
            var startPoint = getMidpoint(pointerTracker.startPointers[0], pointerTracker.startPointers[1]);
            var xPos = startPoint.clientX - _this2.dragStart.rect.x;
            var yPos = startPoint.clientY - _this2.dragStart.rect.y;

            var _this2$getZoomDelta = _this2.getZoomDelta(_this2.content.scale * _this2.dragOffset.scale, xPos, yPos),
                deltaX = _this2$getZoomDelta.deltaX,
                deltaY = _this2$getZoomDelta.deltaY;

            _this2.dragPosition.x -= deltaX;
            _this2.dragPosition.y -= deltaY;
            _this2.dragPosition.midPoint = newMidpoint;
          } else {
            _this2.setDragResistance();
          } // Update final position


          _this2.transform = {
            x: _this2.dragPosition.x,
            y: _this2.dragPosition.y,
            scale: _this2.dragPosition.scale
          };

          _this2.startAnimation();
        },
        end: function end(pointer, event) {
          if (_this2.state !== "pointerdown") {
            return;
          }

          _this2._dragOffset = _objectSpread({}, _this2.dragOffset);

          if (pointerTracker.currentPointers.length) {
            _this2.resetDragPosition();

            return;
          }

          _this2.state = "decel";
          _this2.friction = _this2.option("decelFriction");

          _this2.recalculateTransform();

          _this2.$container.classList.remove(_this2.option("draggingClass"));

          if (_this2.trigger("touchEnd", event) === false) {
            return;
          }

          if (_this2.state !== "decel") {
            return;
          } // * Check if scaled content past limits
          // Below minimum


          var minScale = _this2.option("minScale");

          if (_this2.transform.scale < minScale) {
            _this2.zoomTo(minScale, {
              friction: 0.64
            });

            return;
          } // Exceed maximum


          var maxScale = _this2.option("maxScale");

          if (_this2.transform.scale - maxScale > 0.01) {
            var last = _this2.dragPosition.midPoint || pointer;

            var rect = _this2.$content.getClientRects()[0];

            _this2.zoomTo(maxScale, {
              friction: 0.64,
              x: last.clientX - rect.left,
              y: last.clientY - rect.top
            });

            return;
          }
        }
      });
      this.pointerTracker = pointerTracker;
    }
  }, {
    key: "initObserver",
    value: function initObserver() {
      var _this3 = this;

      if (this.resizeObserver) {
        return;
      }

      this.resizeObserver = new ResizeObserver(function () {
        if (_this3.updateTimer) {
          return;
        }

        _this3.updateTimer = setTimeout(function () {
          var rect = _this3.$container.getBoundingClientRect();

          if (!(rect.width && rect.height)) {
            _this3.updateTimer = null;
            return;
          } // Check to see if there are any changes


          if (Math.abs(rect.width - _this3.container.width) > 1 || Math.abs(rect.height - _this3.container.height) > 1) {
            if (_this3.isAnimating()) {
              _this3.endAnimation(true);
            }

            _this3.updateMetrics();

            _this3.panTo({
              x: _this3.content.x,
              y: _this3.content.y,
              scale: _this3.option("baseScale"),
              friction: 0
            });
          }

          _this3.updateTimer = null;
        }, _this3.updateRate);
      });
      this.resizeObserver.observe(this.$container);
    }
    /**
     * Restore drag related variables to default values
     */

  }, {
    key: "resetDragPosition",
    value: function resetDragPosition() {
      this.lockAxis = null;
      this.friction = this.option("friction");
      this.velocity = {
        x: 0,
        y: 0,
        scale: 0
      };
      var _this$content = this.content,
          x = _this$content.x,
          y = _this$content.y,
          scale = _this$content.scale;
      this.dragStart = {
        rect: this.$content.getBoundingClientRect(),
        x: x,
        y: y,
        scale: scale
      };
      this.dragPosition = _objectSpread(_objectSpread({}, this.dragPosition), {}, {
        x: x,
        y: y,
        scale: scale
      });
      this.dragOffset = {
        x: 0,
        y: 0,
        scale: 1,
        time: 0
      };
    }
    /**
     * Trigger update events before/after resizing content and viewport
     * @param {Boolean} silently Should trigger `afterUpdate` event at the end
     */

  }, {
    key: "updateMetrics",
    value: function updateMetrics(silently) {
      if (silently !== true) {
        this.trigger("beforeUpdate");
      }

      var $container = this.$container;
      var $content = this.$content;
      var $viewport = this.$viewport;
      var contentIsImage = $content instanceof HTMLImageElement;
      var contentIsZoomable = this.option("zoom");
      var shouldResizeParent = this.option("resizeParent", contentIsZoomable);
      var width = this.option("width");
      var height = this.option("height");
      var origWidth = width || getFullWidth($content);
      var origHeight = height || getFullHeight($content);
      Object.assign($content.style, {
        width: width ? "".concat(width, "px") : "",
        height: height ? "".concat(height, "px") : "",
        maxWidth: "",
        maxHeight: ""
      });

      if (shouldResizeParent) {
        Object.assign($viewport.style, {
          width: "",
          height: ""
        });
      }

      var ratio = this.option("ratio");
      origWidth = round(origWidth * ratio);
      origHeight = round(origHeight * ratio);
      width = origWidth;
      height = origHeight;
      var contentRect = $content.getBoundingClientRect();
      var viewportRect = $viewport.getBoundingClientRect();
      var containerRect = $viewport == $container ? viewportRect : $container.getBoundingClientRect();
      var viewportWidth = Math.max($viewport.offsetWidth, round(viewportRect.width));
      var viewportHeight = Math.max($viewport.offsetHeight, round(viewportRect.height));
      var viewportStyles = window.getComputedStyle($viewport);
      viewportWidth -= parseFloat(viewportStyles.paddingLeft) + parseFloat(viewportStyles.paddingRight);
      viewportHeight -= parseFloat(viewportStyles.paddingTop) + parseFloat(viewportStyles.paddingBottom);
      this.viewport.width = viewportWidth;
      this.viewport.height = viewportHeight;

      if (contentIsZoomable) {
        if (Math.abs(origWidth - contentRect.width) > 0.1 || Math.abs(origHeight - contentRect.height) > 0.1) {
          var rez = calculateAspectRatioFit(origWidth, origHeight, Math.min(origWidth, contentRect.width), Math.min(origHeight, contentRect.height));
          width = round(rez.width);
          height = round(rez.height);
        }

        Object.assign($content.style, {
          width: "".concat(width, "px"),
          height: "".concat(height, "px"),
          transform: ""
        });
      }

      if (shouldResizeParent) {
        Object.assign($viewport.style, {
          width: "".concat(width, "px"),
          height: "".concat(height, "px")
        });
        this.viewport = _objectSpread(_objectSpread({}, this.viewport), {}, {
          width: width,
          height: height
        });
      }

      if (contentIsImage && contentIsZoomable && typeof this.options.maxScale !== "function") {
        var maxScale = this.option("maxScale");

        this.options.maxScale = function () {
          return this.content.origWidth > 0 && this.content.fitWidth > 0 ? this.content.origWidth / this.content.fitWidth : maxScale;
        };
      }

      this.content = _objectSpread(_objectSpread({}, this.content), {}, {
        origWidth: origWidth,
        origHeight: origHeight,
        fitWidth: width,
        fitHeight: height,
        width: width,
        height: height,
        scale: 1,
        isZoomable: contentIsZoomable
      });
      this.container = {
        width: containerRect.width,
        height: containerRect.height
      };

      if (silently !== true) {
        this.trigger("afterUpdate");
      }
    }
    /**
     * Increase zoom level
     * @param {Number} [step] Zoom ratio; `0.5` would increase scale from 1 to 1.5
     */

  }, {
    key: "zoomIn",
    value: function zoomIn(step) {
      this.zoomTo(this.content.scale + (step || this.option("step")));
    }
    /**
     * Decrease zoom level
     * @param {Number} [step] Zoom ratio; `0.5` would decrease scale from 1.5 to 1
     */

  }, {
    key: "zoomOut",
    value: function zoomOut(step) {
      this.zoomTo(this.content.scale - (step || this.option("step")));
    }
    /**
     * Toggles zoom level between max and base levels
     * @param {Object} [options] Additional options
     */

  }, {
    key: "toggleZoom",
    value: function toggleZoom() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var maxScale = this.option("maxScale");
      var baseScale = this.option("baseScale");
      var scale = this.content.scale > baseScale + (maxScale - baseScale) * 0.5 ? baseScale : maxScale;
      this.zoomTo(scale, props);
    }
    /**
     * Animate to given zoom level
     * @param {Number} scale New zoom level
     * @param {Object} [options] Additional options
     */

  }, {
    key: "zoomTo",
    value: function zoomTo() {
      var scale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.option("baseScale");

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$x = _ref.x,
          x = _ref$x === void 0 ? null : _ref$x,
          _ref$y = _ref.y,
          y = _ref$y === void 0 ? null : _ref$y;

      scale = Math.max(Math.min(scale, this.option("maxScale")), this.option("minScale")); // Adjust zoom position

      var currentScale = round(this.content.scale / (this.content.width / this.content.fitWidth), 10000000);

      if (x === null) {
        x = this.content.width * currentScale * 0.5;
      }

      if (y === null) {
        y = this.content.height * currentScale * 0.5;
      }

      var _this$getZoomDelta = this.getZoomDelta(scale, x, y),
          deltaX = _this$getZoomDelta.deltaX,
          deltaY = _this$getZoomDelta.deltaY;

      x = this.content.x - deltaX;
      y = this.content.y - deltaY;
      this.panTo({
        x: x,
        y: y,
        scale: scale,
        friction: this.option("zoomFriction")
      });
    }
    /**
     * Calculate difference for top/left values if content would scale at given coordinates
     * @param {Number} scale
     * @param {Number} x
     * @param {Number} y
     * @returns {Object}
     */

  }, {
    key: "getZoomDelta",
    value: function getZoomDelta(scale) {
      var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var currentWidth = this.content.fitWidth * this.content.scale;
      var currentHeight = this.content.fitHeight * this.content.scale;
      var percentXInCurrentBox = x > 0 && currentWidth ? x / currentWidth : 0;
      var percentYInCurrentBox = y > 0 && currentHeight ? y / currentHeight : 0;
      var nextWidth = this.content.fitWidth * scale;
      var nextHeight = this.content.fitHeight * scale;
      var deltaX = (nextWidth - currentWidth) * percentXInCurrentBox;
      var deltaY = (nextHeight - currentHeight) * percentYInCurrentBox;
      return {
        deltaX: deltaX,
        deltaY: deltaY
      };
    }
    /**
     * Animate to given positon and/or zoom level
     * @param {Object} [options] Additional options
     */

  }, {
    key: "panTo",
    value: function panTo() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$x = _ref2.x,
          x = _ref2$x === void 0 ? this.content.x : _ref2$x,
          _ref2$y = _ref2.y,
          y = _ref2$y === void 0 ? this.content.y : _ref2$y,
          scale = _ref2.scale,
          _ref2$friction = _ref2.friction,
          friction = _ref2$friction === void 0 ? this.option("friction") : _ref2$friction,
          _ref2$ignoreBounds = _ref2.ignoreBounds,
          ignoreBounds = _ref2$ignoreBounds === void 0 ? false : _ref2$ignoreBounds;

      scale = scale || this.content.scale || 1;

      if (!ignoreBounds) {
        var _this$getBounds = this.getBounds(scale),
            boundX = _this$getBounds.boundX,
            boundY = _this$getBounds.boundY;

        if (boundX) {
          x = Math.max(Math.min(x, boundX.to), boundX.from);
        }

        if (boundY) {
          y = Math.max(Math.min(y, boundY.to), boundY.from);
        }
      }

      this.friction = friction;
      this.transform = _objectSpread(_objectSpread({}, this.transform), {}, {
        x: x,
        y: y,
        scale: scale
      });

      if (friction) {
        this.state = "panning";
        this.velocity = {
          x: (1 / this.friction - 1) * (x - this.content.x),
          y: (1 / this.friction - 1) * (y - this.content.y),
          scale: (1 / this.friction - 1) * (scale - this.content.scale)
        };
        this.startAnimation();
      } else {
        this.endAnimation();
      }
    }
    /**
     * Start animation loop
     */

  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this4 = this;

      if (!this.rAF) {
        this.trigger("startAnimation");
      } else {
        cancelAnimationFrame(this.rAF);
      }

      this.rAF = requestAnimationFrame(function () {
        return _this4.animate();
      });
    }
    /**
     * Process animation frame
     */

  }, {
    key: "animate",
    value: function animate() {
      var _this5 = this;

      this.setEdgeForce();
      this.setDragForce();
      this.velocity.x *= this.friction;
      this.velocity.y *= this.friction;
      this.velocity.scale *= this.friction;
      this.content.x += this.velocity.x;
      this.content.y += this.velocity.y;
      this.content.scale += this.velocity.scale;

      if (this.isAnimating()) {
        this.setTransform();
      } else if (this.state !== "pointerdown") {
        this.endAnimation();
        return;
      }

      this.rAF = requestAnimationFrame(function () {
        return _this5.animate();
      });
    }
    /**
     * Calculate boundaries
     */

  }, {
    key: "getBounds",
    value: function getBounds(scale) {
      var boundX = this.boundX;
      var boundY = this.boundY;

      if (boundX !== undefined && boundY !== undefined) {
        return {
          boundX: boundX,
          boundY: boundY
        };
      }

      boundX = {
        from: 0,
        to: 0
      };
      boundY = {
        from: 0,
        to: 0
      };
      scale = scale || this.transform.scale;
      var width = this.content.fitWidth * scale;
      var height = this.content.fitHeight * scale;
      var viewportWidth = this.viewport.width;
      var viewportHeight = this.viewport.height;

      if (width < viewportWidth) {
        var deltaX = round((viewportWidth - width) * 0.5);
        boundX.from = deltaX;
        boundX.to = deltaX;
      } else {
        boundX.from = round(viewportWidth - width);
      }

      if (height < viewportHeight) {
        var deltaY = (viewportHeight - height) * 0.5;
        boundY.from = deltaY;
        boundY.to = deltaY;
      } else {
        boundY.from = round(viewportHeight - height);
      }

      return {
        boundX: boundX,
        boundY: boundY
      };
    }
    /**
     * Change animation velocity if boundary is reached
     */

  }, {
    key: "setEdgeForce",
    value: function setEdgeForce() {
      if (this.state !== "decel") {
        return;
      }

      var bounceForce = this.option("bounceForce");

      var _this$getBounds2 = this.getBounds(Math.max(this.transform.scale, this.content.scale)),
          boundX = _this$getBounds2.boundX,
          boundY = _this$getBounds2.boundY;

      var pastLeft, pastRight, pastTop, pastBottom;

      if (boundX) {
        pastLeft = this.content.x < boundX.from;
        pastRight = this.content.x > boundX.to;
      }

      if (boundY) {
        pastTop = this.content.y < boundY.from;
        pastBottom = this.content.y > boundY.to;
      }

      if (pastLeft || pastRight) {
        var bound = pastLeft ? boundX.from : boundX.to;
        var distance = bound - this.content.x;
        var force = distance * bounceForce;
        var restX = this.content.x + (this.velocity.x + force) / this.friction;

        if (restX >= boundX.from && restX <= boundX.to) {
          force += this.velocity.x;
        }

        this.velocity.x = force;
        this.recalculateTransform();
      }

      if (pastTop || pastBottom) {
        var _bound = pastTop ? boundY.from : boundY.to;

        var _distance = _bound - this.content.y;

        var _force = _distance * bounceForce;

        var restY = this.content.y + (_force + this.velocity.y) / this.friction;

        if (restY >= boundY.from && restY <= boundY.to) {
          _force += this.velocity.y;
        }

        this.velocity.y = _force;
        this.recalculateTransform();
      }
    }
    /**
     * Change dragging position if boundary is reached
     */

  }, {
    key: "setDragResistance",
    value: function setDragResistance() {
      if (this.state !== "pointerdown") {
        return;
      }

      var _this$getBounds3 = this.getBounds(this.dragPosition.scale),
          boundX = _this$getBounds3.boundX,
          boundY = _this$getBounds3.boundY;

      var pastLeft, pastRight, pastTop, pastBottom;

      if (boundX) {
        pastLeft = this.dragPosition.x < boundX.from;
        pastRight = this.dragPosition.x > boundX.to;
      }

      if (boundY) {
        pastTop = this.dragPosition.y < boundY.from;
        pastBottom = this.dragPosition.y > boundY.to;
      }

      if ((pastLeft || pastRight) && !(pastLeft && pastRight)) {
        var bound = pastLeft ? boundX.from : boundX.to;
        var distance = bound - this.dragPosition.x;
        this.dragPosition.x = bound - distance * 0.3;
      }

      if ((pastTop || pastBottom) && !(pastTop && pastBottom)) {
        var _bound2 = pastTop ? boundY.from : boundY.to;

        var _distance2 = _bound2 - this.dragPosition.y;

        this.dragPosition.y = _bound2 - _distance2 * 0.3;
      }
    }
    /**
     * Set velocity to move content to drag position
     */

  }, {
    key: "setDragForce",
    value: function setDragForce() {
      if (this.state === "pointerdown") {
        this.velocity.x = this.dragPosition.x - this.content.x;
        this.velocity.y = this.dragPosition.y - this.content.y;
        this.velocity.scale = this.dragPosition.scale - this.content.scale;
      }
    }
    /**
     * Update end values based on current velocity and friction;
     */

  }, {
    key: "recalculateTransform",
    value: function recalculateTransform() {
      this.transform.x = this.content.x + this.velocity.x / (1 / this.friction - 1);
      this.transform.y = this.content.y + this.velocity.y / (1 / this.friction - 1);
      this.transform.scale = this.content.scale + this.velocity.scale / (1 / this.friction - 1);
    }
    /**
     * Check if content is currently animating
     * @returns {Boolean}
     */

  }, {
    key: "isAnimating",
    value: function isAnimating() {
      return !!(this.friction && (Math.abs(this.velocity.x) > 0.05 || Math.abs(this.velocity.y) > 0.05 || Math.abs(this.velocity.scale) > 0.05));
    }
    /**
     * Set content `style.transform` value based on current animation frame
     */

  }, {
    key: "setTransform",
    value: function setTransform(_final) {
      var x, y, scale;

      if (_final) {
        x = round(this.transform.x);
        y = round(this.transform.y);
        scale = this.transform.scale;
        this.content = _objectSpread(_objectSpread({}, this.content), {}, {
          x: x,
          y: y,
          scale: scale
        });
      } else {
        x = round(this.content.x);
        y = round(this.content.y);
        scale = this.content.scale / (this.content.width / this.content.fitWidth);
        this.content = _objectSpread(_objectSpread({}, this.content), {}, {
          x: x,
          y: y
        });
      }

      this.trigger("beforeTransform");
      x = round(this.content.x);
      y = round(this.content.y);

      if (_final && this.option("zoom")) {
        var width;
        var height;
        width = round(this.content.fitWidth * scale);
        height = round(this.content.fitHeight * scale);
        this.content.width = width;
        this.content.height = height;
        this.transform = _objectSpread(_objectSpread({}, this.transform), {}, {
          width: width,
          height: height,
          scale: scale
        });
        Object.assign(this.$content.style, {
          width: "".concat(width, "px"),
          height: "".concat(height, "px"),
          maxWidth: "none",
          maxHeight: "none",
          transform: "translate3d(".concat(x, "px, ").concat(y, "px, 0) scale(1)")
        });
      } else {
        this.$content.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, 0) scale(").concat(scale, ")");
      }

      this.trigger("afterTransform");
    }
    /**
     * Stop animation loop
     */

  }, {
    key: "endAnimation",
    value: function endAnimation(silently) {
      cancelAnimationFrame(this.rAF);
      this.rAF = null;
      this.velocity = {
        x: 0,
        y: 0,
        scale: 0
      };
      this.setTransform(true);
      this.state = "ready";
      this.handleCursor();

      if (silently !== true) {
        this.trigger("endAnimation");
      }
    }
    /**
     * Update the class name depending on whether the content is scaled
     */

  }, {
    key: "handleCursor",
    value: function handleCursor() {
      var draggableClass = this.option("draggableClass");

      if (!draggableClass || !this.option("touch")) {
        return;
      }

      if (this.option("panOnlyZoomed") == true && this.content.width <= this.viewport.width && this.content.height <= this.viewport.height && this.transform.scale <= this.option("baseScale")) {
        this.$container.classList.remove(draggableClass);
      } else {
        this.$container.classList.add(draggableClass);
      }
    }
    /**
     * Remove observation and detach event listeners
     */

  }, {
    key: "detachEvents",
    value: function detachEvents() {
      this.$content.removeEventListener("load", this.onLoad);
      this.$container.removeEventListener("wheel", this.onWheel, {
        passive: false
      });
      this.$container.removeEventListener("click", this.onClick, {
        passive: false
      });

      if (this.pointerTracker) {
        this.pointerTracker.stop();
        this.pointerTracker = null;
      }

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }
    /**
     * Clean up
     */

  }, {
    key: "destroy",
    value: function destroy() {
      if (this.state === "destroy") {
        return;
      }

      this.state = "destroy";
      clearTimeout(this.updateTimer);
      this.updateTimer = null;
      cancelAnimationFrame(this.rAF);
      this.rAF = null;
      this.detachEvents();
      this.detachPlugins();
      this.resetDragPosition();
    }
  }]);

  return Panzoom;
}(Base); // Expose version

Panzoom.version = "__VERSION__"; // Static properties are a recent addition that dont work in all browsers yet

Panzoom.Plugins = Plugins;